export default "__VITE_PUBLIC_ASSET__1de49cf8__"